<template>
  <div>
    <div class="about-hero">
      <div
        class="about-hero__content text-center justify-content-center flex-column align-items-center p-3 text-white"
      >
        <h1 class="font-weight-bold">About NextGen Garage Door Repairs</h1>
        <p class="mt-3">
          Proudly serving New Jersey families and businesses for over 15 years
          with professional garage door repair, installation, and maintenance
          services.
        </p>

        <!-- CTA Buttons -->
        <div class="cta-buttons">
          <a href="tel:5514080587" class="cta-btn cta-btn-primary">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M22 16.92V19.92C22 20.4896 21.5523 20.9725 20.9856 20.9983C20.9056 21.0007 20.8254 21 20.745 20.9967C17.5625 20.7479 14.5398 19.5461 11.9814 17.5416C9.58734 15.6798 7.67339 13.2269 6.41992 10.4134C4.48306 7.55379 3.41191 4.23537 3.30693 0.829765C3.29346 0.353926 3.65569 -0.0407526 4.1296 -0.00289272C4.18541 -0.000967419 4.24124 0.000967419 4.29707 0.00289272H7.29707C8.01696 -0.00403735 8.60958 0.521155 8.69716 1.23192C8.73037 1.54095 8.77305 1.84903 8.8252 2.15518C9.05656 3.47229 9.46138 4.75073 10.0271 5.96022C10.2523 6.48009 10.091 7.08806 9.64263 7.41871L8.21479 8.5418C9.77581 11.3243 12.1039 13.5483 14.9643 14.9651L16.0808 13.5418C16.4171 13.1008 17.0369 12.9425 17.5663 13.1639C18.8063 13.7181 20.1171 14.1134 21.467 14.3392C22.1852 14.4266 22.7168 15.0317 22.7098 15.757L22 16.92Z"
                fill="white"
              />
            </svg>
            (551) 408-0587
          </a>
          <router-link to="/contact" class="cta-btn cta-btn-secondary">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 11L12 14L22 4"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Get Free Quote
          </router-link>
        </div>
      </div>
    </div>

    <AboutUs />
    <AboutValues />
    <AboutLicensed />
  </div>
</template>

<script>
import AboutUs from "../components/AboutUs.vue";
import AboutValues from "../components/AboutValues.vue";
import AboutLicensed from "../components/AboutLicensed.vue";
export default {
  name: "About",
  components: {
    AboutUs,
    AboutValues,
    AboutLicensed,
  },
};
</script>

<style lang="scss" scoped>
.about-hero {
  background-image: url("../assets/imgs/about-us.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 600px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 60%;
    height: 100%;
    background: linear-gradient(
      135deg,
      transparent 0%,
      transparent 30%,
      rgba(13, 71, 161, 0.15) 60%,
      rgba(13, 71, 161, 0.35) 90%,
      rgba(13, 71, 161, 0.5) 100%
    );
    z-index: 2;
  }

  &__content {
    position: relative;
    z-index: 3;
    max-width: 800px;
    padding: 0 15px;

    h1 {
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
      margin-bottom: 1.5rem;
      animation: fadeInDown 1s ease;

      @media (max-width: 768px) {
        font-size: 25px;
      }
    }

    p {
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
      font-size: 1.1rem;
      line-height: 1.6;
      margin-bottom: 2rem;
      animation: fadeInUp 1.2s ease;
    }

    .cta-buttons {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
      justify-content: center;
      animation: fadeInUp 1.4s ease;
    }

    .cta-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      font-size: 16px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 1px;
      color: white;
      border: none;
      border-radius: 50px;
      padding: 16px 32px;
      transition: all 0.3s ease;
      text-decoration: none;
      min-width: 220px;
      cursor: pointer;

      svg {
        transition: transform 0.3s ease;
      }

      &:hover {
        transform: translateY(-2px);
        color: white;
        text-decoration: none;
      }

      &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
      }
    }

    .cta-btn-primary {
      background: #3072d9;
      box-shadow: 0 4px 15px rgba(48, 114, 217, 0.4);

      &:hover {
        background: #0a3a82;
        box-shadow: 0 6px 20px rgba(48, 114, 217, 0.6);
      }

      &:hover svg {
        transform: scale(1.1);
      }
    }

    .cta-btn-secondary {
      background: rgba(255, 255, 255, 0.15);
      backdrop-filter: blur(10px);
      border: 2px solid white;
      box-shadow: 0 4px 15px rgba(255, 255, 255, 0.2);

      &:hover {
        background: rgba(255, 255, 255, 0.25);
        box-shadow: 0 6px 20px rgba(255, 255, 255, 0.3);
      }

      &:hover svg {
        transform: translateX(5px);
      }
    }
  }

  // Animations
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 767.98px) {
    height: 450px;

    &__content {
      .cta-buttons {
        flex-direction: column;
        align-items: center;
        gap: 15px;
      }

      .cta-btn {
        font-size: 14px;
        padding: 14px 28px;
        min-width: 200px;
      }
    }
  }

  @media (max-width: 575.99px) {
    &__content {
      p {
        font-size: 1rem;
        margin-bottom: 1.5rem;
      }

      .cta-btn {
        font-size: 13px;
        padding: 12px 24px;
        min-width: 180px;
      }
    }
  }
}
</style>
